// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.20.1';
//# sourceMappingURL=version.js.map